// Common
import { Inject, Injector, Optional, Pipe, untracked, type PipeTransform, type Signal } from '@angular/core';
import { listWorkspaceScope } from '@modules/common/components/item-workspace/list-workspace-scope';
import { checkExhaustiveness } from '@modules/common/utils/switch';

// Types
import { VirtualFolder } from '../types/virtual-folder';

@Pipe({
  name: 'titleByEventsFilter',
  standalone: false,
  pure: false,
})
export class TitleByEventsFilterPipe implements PipeTransform {
  private workspaceScope?: Signal<'team' | 'mine' | undefined>;

  public constructor(@Optional() @Inject(Injector) private readonly injector: Injector | null = null) {}

  public transform(value: VirtualFolder, containerName?: string | null, nameWorkspace = false): string {
    const injector = this.injector;
    if (nameWorkspace && value === 'all_events' && injector) {
      this.workspaceScope ??= untracked(() => listWorkspaceScope(injector));
      const workspace = this.workspaceScope();
      if (workspace) return `${workspace === 'team' ? 'Team' : 'My'} Events`;
    }
    if (!value) {
      return containerName || 'All';
    }

    switch (value) {
      case 'following':
        return 'Following';
      case 'assigned_to_me':
        return 'Assigned to me';
      case 'search_results':
        return 'All Results';
      case 'all_events':
        return 'Events';
      case 'archived':
        return 'Archive';
      case 'deleted':
        return 'Trash';
      case 'all_calendars':
        return 'Calendars';
      case 'followed':
        return 'Follow Up';
      case 'snoozed':
        return 'Snoozed';
      case 'flagged':
        return 'Flagged';
      case 'received_invites':
        return 'Received Invites';
      case 'sent_invites':
        return 'Sent Invites';
      default:
        return checkExhaustiveness(value);
    }
  }
}
